import React from 'react';

const GameController = props => (
  <svg width={20} height={20} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21 10.565a3.477 3.477 0 0 0-3.478-3.478H4.478A3.477 3.477 0 0 0 1 10.565v8.696C1 20.226 1.783 21 2.74 21c1.295 0 .738-.078 4.347-6.087h7.826C18.461 20.826 17.922 21 19.261 21c.956 0 1.739-.774 1.739-1.74v-8.695Z"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.652 10.13a.435.435 0 1 0 0-.87.435.435 0 0 0 0 .87ZM18.392 11.87a.435.435 0 1 0 0-.87.435.435 0 0 0 0 .87ZM15.219 11.74a.43.43 0 0 1-.618 0 .43.43 0 0 1 0-.618.43.43 0 0 1 .617 0 .43.43 0 0 1 0 .617ZM16.652 13.609a.435.435 0 1 0 0-.87.435.435 0 0 0 0 .87ZM5.348 9.696v3.478M7.086 11.435H3.607M9.26 13.174h.87M11.87 13.174h.869M12.304 5.348H8.826v1.739h3.478v-1.74Z"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.566 5.348V3.174c0-1.2-.974-2.174-2.174-2.174H4.479"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default GameController;
